import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import { CHANNEL_EVENTS, CHANNEL_STATES } from './lib/constants';
import Push from './lib/push';
import Timer from './lib/timer';

var RealtimeSubscription = /*#__PURE__*/function () {
  function RealtimeSubscription(topic) {
    var _this = this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var socket = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, RealtimeSubscription);

    this.topic = topic;
    this.params = params;
    this.socket = socket;
    this.bindings = [];
    this.state = CHANNEL_STATES.closed;
    this.joinedOnce = false;
    this.pushBuffer = [];
    this.timeout = this.socket.timeout;
    this.joinPush = new Push(this, CHANNEL_EVENTS.join, this.params, this.timeout);
    this.rejoinTimer = new Timer(function () {
      return _this.rejoinUntilConnected();
    }, this.socket.reconnectAfterMs);
    this.joinPush.receive('ok', function () {
      _this.state = CHANNEL_STATES.joined;

      _this.rejoinTimer.reset();

      _this.pushBuffer.forEach(function (pushEvent) {
        return pushEvent.send();
      });

      _this.pushBuffer = [];
    });
    this.onClose(function () {
      _this.rejoinTimer.reset();

      _this.socket.log('channel', "close ".concat(_this.topic, " ").concat(_this.joinRef()));

      _this.state = CHANNEL_STATES.closed;

      _this.socket.remove(_this);
    });
    this.onError(function (reason) {
      if (_this.isLeaving() || _this.isClosed()) {
        return;
      }

      _this.socket.log('channel', "error ".concat(_this.topic), reason);

      _this.state = CHANNEL_STATES.errored;

      _this.rejoinTimer.scheduleTimeout();
    });
    this.joinPush.receive('timeout', function () {
      if (!_this.isJoining()) {
        return;
      }

      _this.socket.log('channel', "timeout ".concat(_this.topic), _this.joinPush.timeout);

      _this.state = CHANNEL_STATES.errored;

      _this.rejoinTimer.scheduleTimeout();
    });
    this.on(CHANNEL_EVENTS.reply, function (payload, ref) {
      _this.trigger(_this.replyEventName(ref), payload);
    });
  }

  _createClass(RealtimeSubscription, [{
    key: "rejoinUntilConnected",
    value: function rejoinUntilConnected() {
      this.rejoinTimer.scheduleTimeout();

      if (this.socket.isConnected()) {
        this.rejoin();
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;

      if (this.joinedOnce) {
        throw "tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance";
      } else {
        this.joinedOnce = true;
        this.rejoin(timeout);
        return this.joinPush;
      }
    }
  }, {
    key: "onClose",
    value: function onClose(callback) {
      this.on(CHANNEL_EVENTS.close, callback);
    }
  }, {
    key: "onError",
    value: function onError(callback) {
      this.on(CHANNEL_EVENTS.error, function (reason) {
        return callback(reason);
      });
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      this.bindings.push({
        event: event,
        callback: callback
      });
    }
  }, {
    key: "off",
    value: function off(event) {
      this.bindings = this.bindings.filter(function (bind) {
        return bind.event !== event;
      });
    }
  }, {
    key: "canPush",
    value: function canPush() {
      return this.socket.isConnected() && this.isJoined();
    }
  }, {
    key: "push",
    value: function push(event, payload) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.timeout;

      if (!this.joinedOnce) {
        throw "tried to push '".concat(event, "' to '").concat(this.topic, "' before joining. Use channel.subscribe() before pushing events");
      }

      var pushEvent = new Push(this, event, payload, timeout);

      if (this.canPush()) {
        pushEvent.send();
      } else {
        pushEvent.startTimeout();
        this.pushBuffer.push(pushEvent);
      }

      return pushEvent;
    }
    /**
     * Leaves the channel
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      var _this2 = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;
      this.state = CHANNEL_STATES.leaving;

      var onClose = function onClose() {
        _this2.socket.log('channel', "leave ".concat(_this2.topic));

        _this2.trigger(CHANNEL_EVENTS.close, 'leave', _this2.joinRef());
      }; // Destroy joinPush to avoid connection timeouts during unscription phase


      this.joinPush.destroy();
      var leavePush = new Push(this, CHANNEL_EVENTS.leave, {}, timeout);
      leavePush.receive('ok', function () {
        return onClose();
      }).receive('timeout', function () {
        return onClose();
      });
      leavePush.send();

      if (!this.canPush()) {
        leavePush.trigger('ok', {});
      }

      return leavePush;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     */

  }, {
    key: "onMessage",
    value: function onMessage(event, payload, ref) {
      return payload;
    }
  }, {
    key: "isMember",
    value: function isMember(topic) {
      return this.topic === topic;
    }
  }, {
    key: "joinRef",
    value: function joinRef() {
      return this.joinPush.ref;
    }
  }, {
    key: "sendJoin",
    value: function sendJoin(timeout) {
      this.state = CHANNEL_STATES.joining;
      this.joinPush.resend(timeout);
    }
  }, {
    key: "rejoin",
    value: function rejoin() {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;

      if (this.isLeaving()) {
        return;
      }

      this.sendJoin(timeout);
    }
  }, {
    key: "trigger",
    value: function trigger(event, payload, ref) {
      var close = CHANNEL_EVENTS.close,
          error = CHANNEL_EVENTS.error,
          leave = CHANNEL_EVENTS.leave,
          join = CHANNEL_EVENTS.join;
      var events = [close, error, leave, join];

      if (ref && events.indexOf(event) >= 0 && ref !== this.joinRef()) {
        return;
      }

      var handledPayload = this.onMessage(event, payload, ref);

      if (payload && !handledPayload) {
        throw 'channel onMessage callbacks must return the payload, modified or unmodified';
      }

      this.bindings.filter(function (bind) {
        // Bind all events if the user specifies a wildcard.
        if (bind.event === '*') {
          return event === (payload === null || payload === void 0 ? void 0 : payload.type);
        } else {
          return bind.event === event;
        }
      }).map(function (bind) {
        return bind.callback(handledPayload, ref);
      });
    }
  }, {
    key: "replyEventName",
    value: function replyEventName(ref) {
      return "chan_reply_".concat(ref);
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.state === CHANNEL_STATES.closed;
    }
  }, {
    key: "isErrored",
    value: function isErrored() {
      return this.state === CHANNEL_STATES.errored;
    }
  }, {
    key: "isJoined",
    value: function isJoined() {
      return this.state === CHANNEL_STATES.joined;
    }
  }, {
    key: "isJoining",
    value: function isJoining() {
      return this.state === CHANNEL_STATES.joining;
    }
  }, {
    key: "isLeaving",
    value: function isLeaving() {
      return this.state === CHANNEL_STATES.leaving;
    }
  }]);

  return RealtimeSubscription;
}();

export { RealtimeSubscription as default };